<template>
    <!-- 俱乐部卡片 -->
    <router-link :to="{ name: 'venue',params:{clubId:club.id}}" class="clear mtm venue-card">
        <div class="venue-card__avatar">
            <img v-if="club.logo" :src="club.logo">
            <img v-else src="https://www.buole.com/assets/v2/img/buole_icon.jpg" :alt="club.title">
        </div>
        <div class="venue-card__info">
            <h3 class="cr6 mbn c4 fs3">{{ club.title }}</h3>
            <span class="fs2 c9">地址：{{ club.address }}</span>
        </div>
    </router-link>
</template>
<script>

export default {
    name: 'ClubCard',
    props:{
        club:{  //俱乐部信息
            type: Object,
            required: true
        },
    },
    data(){
        return {
            
        }
    }
}
</script>
<style lang="less" scoped>

.venue-card{
    display: block;
    &__avatar{
        float: left;
        width: .5rem;         
        height: .5rem;
        margin-right: .1rem;
        &>img{
            width: 100%;height: 100%;object-fit: cover;
        }
    }    
}
</style>



// WEBPACK FOOTER //
// src/components/ClubCard.vue